module.exports = __webpack_public_path__ + "static/media/gif.c4ad78c4.png";